/**
  * Suche nach Schlüsselwörtern und Volltextsuche.
  * @namespace v3sWbtPlayerApp:tools:search
  */

/**
 * Lädt den Text-Index und stellt Suchdienste bereit
 * @class service_v3sSearchService
 * @memberOf v3sWbtPlayerApp:tools:search
 */
angular.module('v3sWbtPlayerApp').factory('v3sSearchService', ["$q", "v3sAsideService", "v3sContentPath", "v3sLexikonService", "v3sLoaderService", "v3sSearchIndex", "v3sWbtDataService", function ($q, v3sAsideService, v3sContentPath, v3sLexikonService, v3sLoaderService, v3sSearchIndex, v3sWbtDataService) {
    var WEIGHT_FULLTEXT = 1;
    var WEIGHT_KEYWORD = 10;

    var TYPE_PAGE = "page";
    var TYPE_LEXIKON = "lexikon";

    var loading = null;
    var searchIndex = new v3sSearchIndex();
    var lexikon = null;
    var lexikonElement = null;

    /*
     * Wandert rekursiv durch den Item-Baum und sammelt Schlüsselwörter ein.
     */
    function collectKeywords(item) {
        var i, splitKeywords;

        if (item.keywords && item.path) {
            var splitKeywords = item.keywords.split(",");
            for (i = 0; i < splitKeywords.length; i++) {
                searchIndex.addTerm(splitKeywords[i].trim(), [item.path], WEIGHT_KEYWORD, TYPE_PAGE);
            }
        }

        if (item.children) {
            for (i = 0; i < item.children.length; i++) {
                collectKeywords(item.children[i]);
            }
        }
    }

    /*
     * Wandert rekursiv durch den Item-Baum und sammelt Schlüsselwörter aus den Seitentiteln ein.
     */
    function collectTitleKeywords(item) {
        var i, splitKeywords;

        if (item.title && item.path) {
            var splitKeywords = item.title.replace(/\W/g, " ").split(" ");
            for (i = 0; i < splitKeywords.length; i++) {
                searchIndex.addTerm(splitKeywords[i].trim(), [item.path], WEIGHT_KEYWORD, TYPE_PAGE);
            }
        }

        if (item.children) {
            for (i = 0; i < item.children.length; i++) {
                collectTitleKeywords(item.children[i]);
            }
        }
    }

    function buildSearchIndex(searchIndexData) {
        if (!searchIndexData || !searchIndexData.paths || !searchIndexData.terms) {
            return;
        }

        var i, j, paths, validPaths;
        var validTerms = { terms: [], paths: [] };

        for (i = 0; i < searchIndexData.paths.length; i++) {
            paths = searchIndexData.paths[i];
            validPaths = [];

            for (j = 0; j < paths.length; j++) {
                if (lexikon[paths[j]]) {
                    validPaths.push(paths[j]);
                }
            }

            if (validPaths.length > 0) {
                validTerms.terms.push(searchIndexData.terms[i]);
                validTerms.paths.push(validPaths);
            }
        }

        searchIndex.addTerms(validTerms, WEIGHT_FULLTEXT, TYPE_LEXIKON);
        searchIndex.sortTerms();
    }

    /**
     * Lädt den Text-Index

     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchService
     * @return ein Promise, das aufgelöst wird, wenn die Seite fertig geladen ist
     */
    function init() {
        if (!loading) {
            // Lade Volltextindex
            loading = v3sLoaderService('searchindex.js', v3sContentPath).then(function (searchIndexData) {
                searchIndex.addTerms(searchIndexData, WEIGHT_FULLTEXT, TYPE_PAGE);
                searchIndex.sortTerms();

            }, function () {
                // Wenn es keinen Volltextindex gibt, wenigstens die Titel nehmen
                var wbt = v3sWbtDataService.getWbt();
                collectTitleKeywords(wbt);
                searchIndex.sortTerms();

            }).then(function () {
                // Lade Lexikon-Begriffe
                return v3sLexikonService.getLexikon();

            }).then(function (loadedLexikon) {
                var href, terms, i;

                lexikon = loadedLexikon;

                // Lexikonbegriffe mit hoher Gewichtung hinzufügen
                for (href in lexikon) {
                    terms = lexikon[href].title.split(" ");
                    for (i = 0; i < terms.length; i++) {
                        searchIndex.addTerm(terms[i].trim(), [href], WEIGHT_KEYWORD, TYPE_LEXIKON);
                    }
                }

                searchIndex.sortTerms();
            }).then(function () {
                return v3sLoaderService('lexikonindex.js', v3sContentPath)

            }).then(buildSearchIndex, buildSearchIndex);

            // Lade Stichwörter
            var wbt = v3sWbtDataService.getWbt();
            collectKeywords(wbt);
            searchIndex.sortTerms();
        }

        return loading;
    }

    /**
     * Findet Seiten mit den gegebenen Schlüsselwörtern.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchService
     * @param {string} keywords durch Leerzeichen separierte Schlüsselwörter
     * @param {string} mode nach welchen Inhalten gesucht werden soll, "all", "page" oder "lexikon"
     * @return ein Promise, das mit der Liste der Seiten, auf denen dieses Wort vorkommt aufgelöst wird
     */
    function findPages(keywords, mode) {
        var deferred = $q.defer();

        init().then(function () {
            var i, keywordsArray,
                pages = [];

            if (!mode) {
                mode = "all";
            }

            if (keywords) {
                keywordsArray = keywords.toLocaleLowerCase().split(" ");

                for (i = 0; i < keywordsArray.length; i++) {
                    findPagesSingle(keywordsArray[i], mode, pages);
                }
            }

            deferred.resolve(pages);
        });

        return deferred.promise;
    }

    /*
     * Findet Seiten mit dem gegebenen einzelnen Schlüsselwort
     */
    function findPagesSingle(keyword, mode, pages) {
        var i, j, k, term, page;

        for (i = 0; i < searchIndex.terms.length; i++) {
            term = searchIndex.terms[i].term;
            if (term == keyword) {
                for (j = 0; j < searchIndex.terms[i].paths.length; j++) {
                    page = searchIndex.terms[i].paths[j];
                    for (k = 0; k < pages.length; k++) {
                        if (page.path == pages[k].path) {
                            pages[k].weight += page.weight;
                            page = null;
                            break;
                        }
                    }
                    if (page && (mode === "all" || page.type === mode)) {
                        pages.push({ path: page.path, weight: page.weight, type: page.type });
                    }
                }

                break;
            }
        }
    }

    /**
     * Gibt die Liste der indizierten Wörter zurück.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchService
     * @return ein Promise, das mit der Liste der indizierten Wörter aufgelöst wird
     */
    function getSearchIndex() {
        var deferred = $q.defer();

        init().then(function () {
            deferred.resolve(searchIndex.terms);
        });

        return deferred.promise;
    }

    function getLexikonElement() {
        return lexikonElement;
    }

    function setLexikonElement(element) {
        lexikonElement = element;
    }

    /**
     * Zeigt den Lexikoneintrag mit dem gegebenen Pfad.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchService
     * @param {path} Pfad ("e002.xml") oder ID ("LEXe002") des Lexikoneintrags
     * @return true wenn der Eintrag neu angezeigt wurde, false, wenn er bereits zu sehen war
     */
    function showLexikonEntry(path) {
        if (!path) {
            console.log("Cannot show glossary entry with empty path.");
            return false;
        }

        var entry, entryId;

        // ggf. Pfad aus ID zusammensetzen
        if (path.indexOf("LEX") === 0 && path.lastIndexOf(".xml") != path.length - 4) {
            entryId = path;
            path = entryId.substring(3, path.length) + ".xml";

        } else if (path.lastIndexOf(".xml") === path.length - 4) {
            entryId = "LEX" + path.substring(0, path.length - 4);

        } else {
            entryId = "LEX" + path;
        }

        entry = lexikon[path];

        if (!entry || lexikonElement.$isShown && lexikonElement.$scope.entry && lexikonElement.$scope.entry.id == entryId) {
            return false;
        }

        if (!lexikonElement.$scope.entry) {
            lexikonElement.$scope.entry = {};
        }

        lexikonElement.$scope.entry.id = entryId;
        lexikonElement.$scope.entry.title = entry.title;
        lexikonElement.$scope.entry.graphic = entry.graphic;
        lexikonElement.$scope.entry.content = entry.content;

        if (!lexikonElement.$isShown) {
            lexikonElement.show();
            v3sAsideService.makeDraggable(lexikonElement);
        }

        return true;
    }

    /**
     * Findet den Pfad zum Lexikoneintrag mit dem gegebenen Titel.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchService
     */
    function findLexikonPath(title) {
        if (title && lexikon) {
            for (var path in lexikon) {
                if (lexikon[path].title == title) {
                    return path;
                }
            }
        }

        return null;
    }

    /**
     * Schließt den aktuell angezeigten Lexikoneintrag.
     *
     * @memberOf v3sWbtPlayerApp:tools:search.service_v3sSearchService
     */
    function hideLexikonEntry() {
        lexikonElement.hide();
    }

    return {
        init: init,
        findPages: findPages,
        getSearchIndex: getSearchIndex,
        getLexikonElement: getLexikonElement,
        setLexikonElement: setLexikonElement,
        showLexikonEntry: showLexikonEntry,
        hideLexikonEntry: hideLexikonEntry,
        findLexikonPath: findLexikonPath
    }
}]);